import { Stack, Tooltip } from "@mui/material";
import { ReactComponent as ButtonIcon } from "images/button-icon.svg";
import { ReactComponent as HardButtonIcon } from "images/hard-buttons-icon.svg";
import { ReactComponent as LinkIcon } from "images/link-icon.svg";
import { customColors } from "models/customColors";

export const SourceOfEvent = ({ buttonId, buttonType }) => (
    <Stack
      direction="row"
      gap={0.35}
      sx={{ color: customColors.mainMessageBlue }}
    >
      {buttonId ? (
        buttonType === "Virtual" ? (
          <Tooltip title={"Digital Button"}>
            <ButtonIcon />
          </Tooltip>
        ) : (
          <Tooltip title={"Physical Button"}>
            <HardButtonIcon />
          </Tooltip>
        )
      ) : (
        <Tooltip title="Embedded form or link">
          <LinkIcon />
        </Tooltip>
      )}
    </Stack>
  )